import { render, staticRenderFns } from "./myStudentProductionDetail.vue?vue&type=template&id=51f8c872&scoped=true&"
import script from "./myStudentProductionDetail.vue?vue&type=script&lang=js&"
export * from "./myStudentProductionDetail.vue?vue&type=script&lang=js&"
import style0 from "./myStudentProductionDetail.vue?vue&type=style&index=0&id=51f8c872&lang=less&scoped=true&"
import style1 from "./myStudentProductionDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8c872",
  null
  
)

export default component.exports